import { render, staticRenderFns } from "./LandingNameCarousel.vue?vue&type=template&id=3294a8de&"
import script from "./LandingNameCarousel.vue?vue&type=script&lang=js&"
export * from "./LandingNameCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports